export const BUNDLE_LIST = [
  {
    key: "TYPE",
    value: "type",
    width: 0.2,
  },
  {
    key: "SUBSCRIPTION",
    value: "subscription",
    width: 0.5,
  },
  {
    key: "CURRENT HARDWARE",
    value: "currenthardware",
    width: 1,
  },
  {
    key: "HARDWARE CHANGES",
    value: "hardwarechanges",
    width: 0.8,
  },
  {
    key: "APPROVED CHANGES",
    value: "approvedchanges",
    width: 0.8,
  },
];

export const BADGE_STYLE = {
  core: {
    backgroundColor: "#0077B4",
    color: "white",
  },
  feature: {
    backgroundColor: "white",
    color: "black",
  },
  companion: {
    backgroundColor: "black",
    color: "white",
  },
};

export const HARDWARE_REQUEST_STATUS = {
  CREATED: "Created",
  MODIFIED_PENDING_AGENT: "Pending Agent",
  MODIFIED: "Modified",
  REVERTED_PENDING_AGENT: "Pending Agent",
  CANCELLED: "Cancelled",
  APPROVED: "Approved",
  REVERTED: "Reverted",
  PENDING_AGENT: "Pending Agent",
};
